import classNames from "classnames";

function ModalCloseButton({ onClick, className }) {
  return (
    <button
      className={classNames(
        "h-9 w-max flex flex-row items-center cursor-pointer rounded-sm modal-close-button-background",
        className
      )}
      onClick={onClick}
    >
      <span className="w-full h-full flex flex-row items-center px-1 select-none font-extrabold">
        {/* FIXME: Without the weird padding below, on hover, the background leaves some space on the right */}
        &nbsp;&nbsp;&nbsp;CLOSE&nbsp;&nbsp;&nbsp;
      </span>
    </button>
  );
}

export default ModalCloseButton;
